import React from 'react';
import { getTierColor } from '@/utils/helpers';
import { Award } from 'lucide-react';

export const TierBadge = ({ tier, size = 'md', showIcon = true }) => {
  const colors = getTierColor(tier);
  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base',
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 ${colors.bg} ${colors.text} border ${colors.border} rounded-full font-medium ${sizes[size]}`}
      data-testid={`tier-badge-${tier}`}
    >
      {showIcon && <Award className="w-3.5 h-3.5" />}
      {tier.charAt(0).toUpperCase() + tier.slice(1)}
    </span>
  );
};